import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoadingPage } from '@/components/layout/loading-page';
import { getAuthMode } from '@/lib/auth/auth-mode';
import { ssoHandleCallback } from '@/lib/auth/sso-auth';
import { useAuthStore } from '@/stores/auth-store';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setUser = useAuthStore((s) => s.setUser);
  const setStatus = useAuthStore((s) => s.setStatus);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (getAuthMode() !== 'sso') {
      navigate('/', { replace: true });
      return;
    }

    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code || !state) {
      setError('Missing authorization code or state parameter.');
      setStatus('unauthenticated');
      return;
    }

    ssoHandleCallback(code, state)
      .then(({ user }) => {
        setUser(user);
        navigate('/', { replace: true });
      })
      .catch((err) => {
        const detail = err instanceof Error ? err.message : String(err);
        console.error('SSO callback failed:', err);
        setError(`Sign-in failed: ${detail}`);
        setStatus('unauthenticated');
      });
  }, [navigate, searchParams, setUser, setStatus]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted p-4">
        <div className="w-full max-w-md rounded-lg border bg-card p-6 text-center">
          <p className="mb-4 text-sm text-destructive">{error}</p>
          <button
            onClick={() => navigate('/login', { replace: true })}
            className="text-sm text-primary underline"
          >
            Return to login
          </button>
        </div>
      </div>
    );
  }

  return <LoadingPage />;
}
